import { render, staticRenderFns } from "./ActionNeededExpensesWidget.vue?vue&type=template&id=62a58c4c&scoped=true"
import script from "./ActionNeededExpensesWidget.vue?vue&type=script&lang=ts"
export * from "./ActionNeededExpensesWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a58c4c",
  null
  
)

export default component.exports